import type { Mission } from '../missions.ts'

export const nrc: Mission = {
  id: "nrc",
  name: "Nuclear Regulatory Commission",
  short: "NRC",
  call: "Nuclear Safety",
  kind: "independent",
  url: "https://www.nrc.gov/",
  established: 1975,
  palette: {
    primary: "#014787",
    secondary: "#303f5b",
    accent: "#ff9f31",
  },
  colorSource: {
    kind: "site",
    url: "https://www.nrc.gov/",
  },
  motif: "eagle",
  mission: {
    text: "NRC was created as an independent agency by Congress in 1974 to ensure the safe use of radioactive materials for beneficial civilian purposes.",
    url: "https://www.nrc.gov/about-nrc/nrc-background",
  },
  fact: {
    text: "The Energy Reorganization Act of 1974 created the NRC, which began operations on January 19, 1975.",
    url: "https://www.nrc.gov/about-nrc/history",
  },
  seal: {
    file: "public/seals/nrc.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Nuclear_Regulatory_Commission.png",
  },
  identifier: {
    about: "https://www.nrc.gov/about-nrc",
    accessibility: "https://www.nrc.gov/site-help/access",
    foia: "https://www.nrc.gov/documents-reports/document-collections/foia",
    noFear: "https://www.nrc.gov/about-nrc/civil-rights/programs/crp/dca",
    oig: "https://nrcoig.oversight.gov/",
    performance: "https://www.nrc.gov/about-nrc/plans-budgets-performance",
    privacy: "https://www.nrc.gov/privacy/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/nrc-headquarters.jpg",
        small: "/media/nrc-headquarters-sm.jpg",
        alt: "The NRC headquarters towers in Rockville, Maryland, rising above green trees under a partly cloudy sky.",
        title: "NRC headquarters campus, Rockville, Maryland, 2012",
        creator: "U.S. Nuclear Regulatory Commission",
        source: "https://commons.wikimedia.org/wiki/File:NRC_Headquarters_-_Rockville,_Md._Campus_(8432039509).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/nrc-cooling-tower.jpg",
        small: "/media/nrc-cooling-tower-sm.jpg",
        alt: "Aerial view of a single concrete cooling tower beside the Columbia River, with forested hills beyond.",
        title: "Trojan Nuclear Power Plant cooling tower, Columbia River, Oregon",
        creator: "U.S. Department of Energy",
        source: "https://commons.wikimedia.org/wiki/File:Trojan_Nuclear_Power_Plant_(11842581485).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
